/* eslint-disable react/prop-types */

import React, { useEffect, useState } from 'react';
import { find } from 'lodash';
import { Row, Col } from 'reactstrap';
import { Field, useSession } from '@cordata/buffet';
import { useFormikContext } from 'formik';

import { authorizedInstance as axios } from '~/utils';

const LocationForm = () => {
  const {
    values,
    status,
    setFieldValue,
    setStatus,
  } = useFormikContext();
  const [states, setStates] = useState([]);
  const { debugMode } = useSession();

  useEffect(() => {
    axios
      .get('reference-country-divisions')
      .then(r => r.data.data)
      .then((r) => {
        setStates(r);

        if (values.state && values.state.length === 2) {
          setFieldValue('state', find(r, s => (values.state === s.attributes.divisionAbbrevIso)));
        }
      });
  }, [values.state]);

  const onPostCodeChange = (postCode) => {
    if (postCode.length >= 5) {
      setStatus({
        county: {
          loading: true,
        },
        city: {
          loading: true,
        },
        state: {
          loading: true,
        },
      });

      axios
        .get(`reference-data/reference-geo-data?zip_code=${postCode}`)
        .then(r => r.data.data)
        .then(r => r[0])
        .then((r) => {
          setFieldValue('county', r ? r.attributes.county : undefined);
          setFieldValue('city', r ? r.attributes.city : undefined);
          setFieldValue('state', find(states, s => r && s.attributes.divisionAbbrevIso === r.attributes.state));

          setStatus({
            county: {
              loading: false,
            },
            city: {
              loading: false,
            },
            state: {
              loading: false,
            },
          });
        });
    }
  };

  useEffect(() => {
    if (values.postCode && values.postCode.length >= 5) {
      onPostCodeChange(values.postCode);
    }
  }, [values.postCode]);

  return (
    <>
      {debugMode && (
        <Field
          name="id"
          label="ID"
          placeholder="ID"
          disabled
        />
      )}

      <Field
        name="address1"
        loading={status && status.address ? status.address.loading : undefined}
      />

      <Row form>
        <Col sm>
          <Field
            name="postCode"
            loading={status && status.postCode ? status.postCode.loading : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name="city"
            loading={status && status.city ? status.city.loading : undefined}
          />
        </Col>

        <Col sm>
          <Field
            name="state"
            type="select"
            options={states}
            loading={status && status.state ? status.state.loading : undefined}
            getOptionValue={o => o.attributes.divisionAbbrevIso}
            getOptionLabel={o => o.attributes.divisionLabel}
          />
        </Col>

        <Col sm>
          <Field
            name="county"
            loading={status && status.county ? status.county.loading : undefined}
          />
        </Col>
      </Row>

      {debugMode && (
        <Row form>
          <Col sm>
            <Field
              name="latitude"
              label="Latitude"
              disabled
            />
          </Col>

          <Col sm>
            <Field
              name="longitude"
              label="Longitude"
              disabled
            />
          </Col>
        </Row>
      )}
    </>
  );
};

export default LocationForm;
